module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedicationPage",
    attrs: {
      "id": "ded"
    }
  }, [_c('a', {
    attrs: {
      "id": "page06"
    }
  }, [_c('p', {
    staticClass: "dedicationText"
  }, [_vm._v("To my wonderful Steeple Hill editors"), _c('br'), _vm._v(" Melissa Endlich, Emily Rodmell and Tina James."), _c('br'), _vm._v(" Thank you for your encouragement and wisdom."), _c('br'), _vm._v(" To my beloved grandchildren Tyler, Drew,"), _c('br'), _vm._v(" Lauren and Carter. God bless you for giving me"), _c('br'), _vm._v(" fresh eyes, endless joy and hope for the future."), _c('br'), _vm._v(" To the Daves, our sons by marriage, and my"), _c('br'), _vm._v(" husband, Dale—your steadfast faith is a"), _c('br'), _vm._v(" role model for our family.")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page06"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a9324cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/substitutebridethe_ded.vue
// module id = 72
// module chunks = 0